import { render, staticRenderFns } from "./AdsSpace.vue?vue&type=template&id=70361a3d"
import script from "./AdsSpace.vue?vue&type=script&lang=js"
export * from "./AdsSpace.vue?vue&type=script&lang=js"
import style0 from "./AdsSpace.vue?vue&type=style&index=0&id=70361a3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports